function LoadingButton({ onClick, loading, title }) {
  return (
    <button
      type="button"
      className="btn btn-outline-secondary"
      onClick={() => onClick()}
      disabled={loading}
    >
      {title || "Mehr laden"}
    </button>
  );
}

export default LoadingButton;
